// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-draggable[data-v-5d996bc4] {\n  cursor: no-drop;\n}\n.item-drag-handle[data-v-5d996bc4] {\n  cursor: move;\n}", ""]);
// Exports
module.exports = exports;
